import { configureStore } from "@reduxjs/toolkit";

import announcementReducer from "./announcement";
import authReducer from "./auth";
import bankReducer from "./bank";
import bettingrecordReducer from "./bettingrecord";
import contactReducer from "./contact";
import depositReducer from "./deposit";
import gameReducer from "./game";
import masterReducer from "./master";
import memberVipReducer from "./memberVip";
import messageReducer from "./message";
import ordersReducer from "./orders";
import retriveReducer from "./retrive";
import userReducer from "./user";
import withdrawReducer from "./withdraw";

const rootReducers = {
  auth: authReducer,
  master: masterReducer,
  game: gameReducer,
  bettingRecord: bettingrecordReducer,
  user: userReducer,
  deposit: depositReducer,
  bank: bankReducer,
  withdraw: withdrawReducer,
  announcement: announcementReducer,
  orders: ordersReducer,
  contact: contactReducer,
  retrive: retriveReducer,
  message: messageReducer,
  memberVip: memberVipReducer,
};

const store = configureStore({
  reducer: rootReducers,
});

export default store;
